export function getEventListReturnPath(location) {
  if (location.state?.from) return location.state.from;

  const basePath = location.pathname.includes('/event/')
    ? (location.pathname.split('/event/')[0] || '/')
    : '/';

  return `${basePath}${location.search || ''}`;
}

export function buildRelatedEventNavigationState(location) {
  return {
    ...location.state,
    from: getEventListReturnPath(location),
  };
}
